import { Typography } from '@/components/ui/typography';
import type { Columns } from '@/types/table';

interface ErrorDetailsCardProps {
  columns: Columns[];
  row: Record<string, unknown>;
}

/**
 * Sub-lg card equivalent of an ErrorDetailsTable row (DataTable's
 * renderMobileCard slot). Generic over the column metadata so the property
 * and order variants share one card — every column the table shows renders
 * as a labeled field, reusing the row's EditableCell components.
 */
export function ErrorDetailsCard({ columns, row }: ErrorDetailsCardProps) {
  return (
    <div
      className="rounded-lg border border-border bg-card p-4"
      data-testid="error-details-card"
    >
      <dl className="flex flex-col gap-3">
        {columns.map((column) => {
          const cell = row[column.selector] as
            | { component?: React.ReactNode }
            | undefined;
          return (
            <div key={column.selector} className="flex flex-col gap-1">
              <dt>
                <Typography as="span" variant="small" className="text-muted-foreground">
                  {column.name}
                  {column.isMandatory && <span className="text-destructive"> *</span>}
                </Typography>
              </dt>
              <dd className="m-0">
                {cell?.component ?? <span className="text-muted-foreground">-</span>}
              </dd>
            </div>
          );
        })}
      </dl>
    </div>
  );
}
